export enum HealthStatus {
  green = "green",
  red = "red",
  yellow = "yellow",
  black = "black",
}

export const HealthStatusHumanReadable: Record<HealthStatus, string> = {
  [HealthStatus.green]: "No issues",
  [HealthStatus.red]: "Service recommended immediately",
  [HealthStatus.yellow]: "Service recommended soon",
  [HealthStatus.black]: "Unmonitored"
}

export const HealthStatusBackgroundColors: Record<HealthStatus, string> = {
  [HealthStatus.green]: 'bg-green-500',
  [HealthStatus.red]: 'bg-red-500',
  [HealthStatus.yellow]: 'bg-yellow-500',
  [HealthStatus.black]: 'bg-gray-300'
};
